import { BordOneToneIcon } from 'components/NudosComponents';
import { bordColorTheme } from '../../../../../../../styles/styles.constants';
import './AddSuggestionButton.scss';

interface IAddSuggestionButton {
  currentCount: number;
  maxCount: number;
  onClick: () => void;
}

/** Botón para agregar una herramienta sugerida adicional al ítem de cotización. */
const AddSuggestionButton = ({ currentCount, maxCount, onClick }: IAddSuggestionButton) => (
  <button className="addSuggestionButton" onClick={onClick}>
    <BordOneToneIcon variant="plus" standardSize={18} stroke={bordColorTheme.navyBlue[900]} />
    Sugerir otra herramienta
    <span className="suggestionCount">
      ({currentCount} de {maxCount})
    </span>
  </button>
);

export default AddSuggestionButton;
